import React from 'react';
import { useIntl } from 'react-intl';
import { Divider } from 'antd';
import ContainerWrapper from 'Common/Components/ContainerWrapper';
import { Tabs } from 'Common/Components/Tabs';
import FailedReceiptsContainer from '../components/FailedReceipts';
import SettingsContainer from '../components/Settings';
import InitReceiptContainer from '../components/InitialReceipt';
import LogsContainer from '../components/Logs';
import ZeroReceiptContainer from '../components/ZeroReceipt';
import DepExportContainer from '../components/DepExport';

const RksvScreen = () => {
  const intl = useIntl();
  return (
    <Tabs
      defaultActiveKey="1"
      items={[
        {
          key: '1',
          label: intl.formatMessage({ defaultMessage: 'Setup' }),
          children: (
            <>
              <ContainerWrapper css="min-height: 280px!important">
                <SettingsContainer />
              </ContainerWrapper>
              <ContainerWrapper css="min-height: 420px!important">
                <InitReceiptContainer />
              </ContainerWrapper>
            </>
          ),
        },
        {
          key: '2',
          label: intl.formatMessage({
            defaultMessage: 'Receipts logs',
            description: 'rksv receipts logs',
          }),
          children: (
            <ContainerWrapper css="padding: 1em">
              <ZeroReceiptContainer />
              <Divider type="horizontal" />
              <LogsContainer />
            </ContainerWrapper>
          ),
        },
        {
          key: '3',
          label: intl.formatMessage({
            defaultMessage: 'Failed receipts',
            description: 'rksv failed receipts',
          }),
          children: (
            <ContainerWrapper css="padding: 1em">
              <FailedReceiptsContainer />
            </ContainerWrapper>
          ),
        },
        {
          key: '4',
          label: intl.formatMessage({
            defaultMessage: 'DEP Export',
            description: 'rksv dep exports',
          }),
          children: (
            <ContainerWrapper css="padding: 1em">
              <DepExportContainer />
            </ContainerWrapper>
          ),
        },
      ]}
    />
  );
};

export default RksvScreen;
